import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricSearchRankLostImpressionShareGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_search_rank_lost_impression_share",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.searchRankLostImpressionShare.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.searchRankLostImpressionShare.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.searchRankLostImpressionShare.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricSearchRankLostImpressionShareGhaPPA;
